export default "__VITE_ASSET__trCniwI0__"